<div class="flex items-center justify-center dialog-header ">

  Bulk Upload

  <div class="absolute right-2">
    <button (click)="handleCloseDialog()" class="outline-none p-5">
      <i class="pi pi-times"></i>
    </button>
  </div>

</div>
<div class="dialog-content" style="position: relative;">


  <div class="drop_box" style="position: relative;" *ngIf="sheetNames.length == 0 && columns?.length == 0">
    <h3>Upload Bulk Data</h3>

    <div class="form-group" *ngIf="isAdmin">
      <div class="mb-1">
        <label>Select Assigned To</label>
      </div>
      <p-select [options]="users" appendTo="body" [(ngModel)]="currentUserId" placeholder="Select Assigned To"
        class="w-full">
      </p-select>

        <small class="mt-2">Files Supported: Excel/CSV Only</small>
    </div>

  

    <div class="mt-5 flex flex-col items-center">
      <input type="file" #fileInput (change)="onFileUpload($event)" hidden accept=".xlsx,.csv" id="fileID"
        style="display:none;">
      <p-button label="Choose File" (click)="fileInput.click()"></p-button>
      <a class="sample_down mt-3" (click)="downloadSampleExcel()">Download sample excel format</a>
    </div>


    <div style="margin-top: 20px;" class="flex flex-col items-center gap-5">
      <label style="text-align: center;">
        Please click the info button to view mandatory column data and fields to be filled for the excel sheet.<br>
        <i style="cursor: pointer; " class="pi pi-info-circle mt-2" 
        (click)="handleOpenColumnInfo()"
        ></i>
      </label>
    </div>

  </div>

  <div *ngIf="sheetNames.length">
    <label for="sheets">Select a Sheet:</label>
    <p-select [options]="sheetNames" [(ngModel)]="selectedSheet" (onChange)="onSheetSelect($event)"
      placeholder="Select a Sheet" class="w-full">
    </p-select>
    <hr />
  </div>

  <div *ngIf="displayedColumns?.length && columns.length" class="columns-body">
    <h3 style="margin-top: 0px; margin-bottom: -7px; font-size: 18px; text-decoration: underline;">
      Map Columns
    </h3>
    <div style="font-size: 13px; margin-top: 10px; margin-bottom: 20px;">
      Select the columns from the excel sheet to map with the fields in the system.
    </div>
    <div *ngFor="let displayColumn of displayedColumns" class="flex align-items-center gap-3 mb-3">
      <div style="flex:2">
        <label>{{ convertColumnName(displayColumn) }}:</label>
      </div>
      <div style="flex:3">
        <p-select [options]="columns" [(ngModel)]="mappedColumns[displayColumn?.field]"
          placeholder="Select Excel Column" class="w-full">
        </p-select>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-4" *ngIf="sheetNames.length || columns.length">
      <p-button label="Close" (click)="handleCloseDialog()" 
      severity="danger"
      variant="outlined"
      >
    </p-button>
      <p-button [disabled]="isLoading" label="{{ !isLoading ? 'Upload Data' : 'Uploading...'}}" icon="pi pi-save"
        [loading]="isLoading" (click)="onSubmit()">
      </p-button>

    </div>

  </div>

<p-dialog
appendTo="body"
[modal]="true" [(visible)]="isOpenColumnInfo" [breakpoints]="{ '1199px': '65vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '45vw' }" [draggable]="false" [resizable]="false">
  <app-column-info (closeDialog)="isOpenColumnInfo = false" 
    [allLeadFeilds]="allLeadFeilds"
    ></app-column-info>
</p-dialog>